export const JOBS_PAGE_SIZE = 12;
export const JOBS_MOBILE_PAGE_SIZE = 6;
export const JOBS_PREVIEW_COUNT = 6;

export function getJobsPageSize(isMobile: boolean): number {
  return isMobile ? JOBS_MOBILE_PAGE_SIZE : JOBS_PAGE_SIZE;
}

/** Reads the `page` query param, falling back to the first page. */
export function parseJobsPage(value: string | null): number {
  const page = Number(value);
  if (!Number.isFinite(page) || page < 1) {
    return 1;
  }

  return Math.floor(page);
}

/** Pages past the last result page fall back to the first page. */
export function clampJobsPage(page: number, totalPages: number): number {
  if (totalPages > 0 && page > totalPages) {
    return 1;
  }

  return page;
}

export function getJobsRange(
  page: number,
  pageSize: number,
  visibleCount: number,
  total: number
): { from: number; to: number } {
  const from = (page - 1) * pageSize + 1;
  if (total <= 0 || from > total) {
    return { from: 0, to: 0 };
  }

  const to = Math.min((page - 1) * pageSize + visibleCount, total);
  return { from, to };
}
